var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7367 12.7624L10.3908 1.12479C10.2056 0.784458 9.93201 0.500363 9.5989 0.302417C9.26579 0.104472 8.88548 0 8.498 0C8.11051 0 7.7302 0.104472 7.39709 0.302417C7.06398 0.500363 6.79041 0.784458 6.60517 1.12479L0.262575 12.7618C0.0839298 13.0898 -0.00642859 13.4586 0.000355734 13.832C0.00714005 14.2054 0.110834 14.5707 0.301276 14.892C0.491718 15.2133 0.762372 15.4796 1.08671 15.6648C1.41105 15.85 1.77795 15.9478 2.15145 15.9485H14.8445C15.2185 15.9485 15.586 15.8512 15.911 15.6661C16.236 15.4811 16.5072 15.2147 16.6981 14.8931C16.889 14.5715 16.9929 14.2058 16.9996 13.8319C17.0064 13.458 16.9158 13.0887 16.7367 12.7604V12.7624ZM15.5653 14.2217C15.4925 14.3481 15.3874 14.4528 15.2607 14.5251C15.134 14.5973 14.9904 14.6345 14.8445 14.6328H2.15145C2.00613 14.6327 1.86335 14.5948 1.7371 14.5228C1.61085 14.4509 1.50546 14.3473 1.43126 14.2224C1.35706 14.0974 1.3166 13.9553 1.31384 13.8101C1.31109 13.6648 1.34613 13.5213 1.41553 13.3936L7.76208 1.75859C7.83414 1.62632 7.94052 1.51591 8.07002 1.43899C8.19952 1.36206 8.34737 1.32147 8.498 1.32147C8.64862 1.32147 8.79647 1.36206 8.92597 1.43899C9.05548 1.51591 9.16185 1.62632 9.23391 1.75859L15.5805 13.3936C15.6518 13.5205 15.688 13.6641 15.6853 13.8097C15.6826 13.9553 15.6412 14.0975 15.5653 14.2217Z",
    fill: "url(#paint0_linear_1691_218)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49794 4.68164C8.32321 4.68164 8.15563 4.75105 8.03208 4.87461C7.90852 4.99816 7.83911 5.16574 7.83911 5.34047V9.9523C7.83911 10.127 7.90852 10.2946 8.03208 10.4182C8.15563 10.5417 8.32321 10.6111 8.49794 10.6111C8.67268 10.6111 8.84026 10.5417 8.96381 10.4182C9.08737 10.2946 9.15678 10.127 9.15678 9.9523V5.34047C9.15678 5.16574 9.08737 4.99816 8.96381 4.87461C8.84026 4.75105 8.67268 4.68164 8.49794 4.68164Z",
    fill: "url(#paint1_linear_1691_218)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49794 12.5892C8.86181 12.5892 9.15678 12.2942 9.15678 11.9303C9.15678 11.5665 8.86181 11.2715 8.49794 11.2715C8.13408 11.2715 7.83911 11.5665 7.83911 11.9303C7.83911 12.2942 8.13408 12.5892 8.49794 12.5892Z",
    fill: "url(#paint2_linear_1691_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1691_218",
    x1: -0.265813,
    y1: 16.9975,
    x2: 13.6259,
    y2: 0.75099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420849,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494208,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#2A6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1691_218",
    x1: 7.81851,
    y1: 11.0011,
    x2: 10.2249,
    y2: 10.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420849,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494208,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#2A6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1691_218",
    x1: 7.81851,
    y1: 12.6758,
    x2: 8.97536,
    y2: 11.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420849,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494208,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#2A6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6767"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseWarningIcon);
export default __webpack_public_path__ + "static/media/pulse-warning-icon.25f8cd4d79037959acfad40c57f43298.svg";
export { ForwardRef as ReactComponent };